import { useTranslation as e } from "../../i18n.mjs";
import { ToolbarSelect as t } from "../../components/content-controls/toolbar-select.mjs";
import { ToolbarSheetSelect as n } from "../../components/content-controls/toolbar-sheet-select.mjs";
import { useEditorState as r } from "@tiptap/react";
import { useMemo as i } from "react";
import { jsx as a } from "react/jsx-runtime";
//#region src/extensions/substitutes-extension/use-substitutes-extension-toolbar.tsx
var o = (o, s) => {
	let { t: c } = e(), l = s?.substitutions, u = !r({
		editor: o,
		selector: ({ editor: e }) => ({ isEditable: e?.options.editable ?? !1 })
	})?.isEditable;
	return i(() => {
		let e = (e) => {
			if (!o) return null;
			o.chain().focus().insertContent(e).run();
		};
		return {
			toolbarRender: /* @__PURE__ */ a(t, {
				disabled: u,
				label: c("substitute_variables"),
				labelledByContent: !0,
				onChange: e,
				options: l ?? [],
				children: c("substitutions")
			}),
			sheetRender: /* @__PURE__ */ a(n, {
				disabled: u,
				label: c("substitutions"),
				onChange: e,
				options: l ?? []
			})
		};
	}, [
		o,
		u,
		l,
		c
	]);
};
//#endregion
export { o as useSubstitutesExtensionToolbar };
